import { Boundaries } from "@planzone/core";
import { Identifiable, Task } from "@planzone/dto";

function handleRemoveTagRequest(
  task: Identifiable<Task>,
  { removableId, tag }: Boundaries["removeTag"]["request"],
): Identifiable<Task> {
  return task.uuid === removableId
    ? {
        ...task,
        tags: task.tags.filter(({ name }) => name !== tag.name),
      }
    : task;
}

function handleRemoveTagSuccess(
  task: Identifiable<Task>,
  { removableId, tag }: Boundaries["removeTag"]["success"],
): Identifiable<Task> {
  return task.uuid === removableId
    ? {
        ...task,
        tags: task.tags.filter(({ name }) => name !== tag.name),
      }
    : task;
}

function handleRemoveTagFailure(
  task: Identifiable<Task>,
  { removableId, tag }: Boundaries["removeTag"]["failure"],
): Identifiable<Task> {
  return task.uuid === removableId
    ? {
        ...task,
        tags: task.tags ? [...task.tags, tag] : [tag],
      }
    : task;
}

export {
  handleRemoveTagRequest,
  handleRemoveTagSuccess,
  handleRemoveTagFailure,
};
